import React from 'react';
import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children, user, requiredRole }) => {
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole) {
    const allowed = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!allowed.includes(user.role) && user.role !== 'admin') {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};